module.exports = __webpack_public_path__ + "img/img_5.3c351409.png";